import { useState, useEffect, useMemo, forwardRef } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  ListSubheader,
  TextField,
  InputAdornment,
} from '@mui/material';
import { getAllEmployees } from 'src/services/employeeService';
import { EmployeeInformation } from 'src/models/employee';
import SearchIcon from '@mui/icons-material/Search';

interface ResourceMultiSelectProps {
  value: string | string[] | [],
  onChange: (e: any) => void,
}

const ResourceMultiSelect = forwardRef((props: ResourceMultiSelectProps, _ref) => {
  const [resources, setResources] = useState<EmployeeInformation[]>([]);
  const [selectedResources, setSelectedResources] = useState<string[]>([]);
  const [searchText, setSearchText] = useState<string>('');
  
  const containsText = (text, searchText) =>
    text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;

  useEffect(() => {
    const fetchResources = () => {
      getAllEmployees().then((res) => {
        const sortedData = res.data.filter(e => !e?.employeeFinance?.isResign).sort((a, b) =>
        b.createdOn.localeCompare(a.createdOn));
        setResources((sortedData as EmployeeInformation[]) || []);
      });
    }

    fetchResources();
  }, []);


  const filteredResources = useMemo(
    () =>
      resources.length > 0 &&
      resources?.filter((option) => containsText(option?.name, searchText)),
    [resources, searchText]
  );

  useEffect(() => {
    const resourcesSelectedName = [];
    if(props?.value && props?.value.length > 0){
      for(let i=0; i < props?.value.length; i++){
        const result = resources.filter(e => e.employeeId.toString() === props?.value[i]);
        resourcesSelectedName.push(result[0]?.name);
      }
    }
    setSelectedResources(resourcesSelectedName);
  }, [resources, props?.value]);

  return (
    <FormControl fullWidth>
      <InputLabel
        style={{
          fontSize: '12px'
        }}
      >
        Resource Name
      </InputLabel>
      <Select
        id="filter-resource"
        sx={{ mt: 1 }}
        style={{
          fontSize: '12px',
          height: '2rem'
        }}
        multiple
        size="small"
        value={props.value}
        renderValue={() => selectedResources.join(', ')}
        onChange={(e) => props?.onChange(e)}
        onClose={() => setSearchText('')}
      >
        <ListSubheader>
          <TextField
            id="search-stakeholderRole"
            size="small"
            autoFocus
            placeholder="Type to search..."
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            onChange={(e) => setSearchText(e.target.value)}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onKeyDown={(e) => {
              if (e.key !== 'Escape') {
                e.stopPropagation();
              }
            }}
          ></TextField>
        </ListSubheader>
        {
          filteredResources?.length > 0 &&
          filteredResources.map((resource, i) => {
            return (
              <MenuItem key={resource?.employeeId} 
                value={resource?.employeeId}>
                  <Checkbox checked={props?.value.indexOf(resource?.employeeId as never) > -1} />
                  <ListItemText primary={resource?.name} />
              </MenuItem>
            );
          })
        }
      </Select>
    </FormControl>
  );
});

export default ResourceMultiSelect;
